/**
 * 报表页面 按钮打点方法
 * src/pages/datalab/pages/WorkBench
 */
import { history } from "umi";
import { operationLog } from "@home/services/home";
import { getLocaleState } from "@home/utils/state";
import { DropPageBtnPointType } from "./types";

/**
 * 新建报表
 * pageId: 601201 pageName: 新建报表
 * 报表编辑
 * pageId: 601202 pageName: 报表名称
 * 报表预览:
 * pageId: "601301"  pageName: 报表名称
 *
 * 模板报表预览:
 * pageId: 601601  pageName: 报表名称
 * 模板报表编辑
 * pageId: 601602 pageName 报表名称
 */

export const dashboardPageBtnPoints = ({extInfo, buttonId, uid, gameName, buttonName, typeId = 'datalab_pc_v2'}:DropPageBtnPointType) => {
  
  const params = {
    uid, gameName, typeId, pageId: '',
  };
  const allExtInfo = {
    // dashboardId,
    // pageName: dashboardName,
    ...extInfo,
  };
  // 承接页面打点
  const datalabReportInfo: any = getLocaleState('datalabReportInfo'); // 获取承接页面信息
  if (datalabReportInfo) {
    // 如果是承接页面, 那么从全局对象中获取传递过来的数据
    const { uid, reportPageId, dashboardName, pageName, dashboardId, ...rest} = datalabReportInfo;
    params.pageId = reportPageId;
    Object.assign(params, rest);
    if (uid) {
      params.uid = uid;
    } else {
      // 舆情和情报系统 没有 uid和uid_type
      params.uidType = undefined;
    }
    allExtInfo.pageName = pageName;
    allExtInfo.dashboardId = dashboardId;
    allExtInfo.dashboardName = dashboardName;
    
  } else {
    // Datalab系统页面
    const { dashboardId, dashboardName = '新建报表', isTemplateReport } = history.location?.query?.dashboardMsg ? JSON.parse(history.location.query.dashboardMsg) : history.location?.query;
    
    if (!dashboardId) {
      // dashboardId 不存在 代表是 报表创建页面
      params.pageId = '601201';
      allExtInfo.pageName = '新建报表';
    } else {
      // 额外信息
      allExtInfo.pageName = dashboardName;
      allExtInfo.dashboardName = dashboardName;
      allExtInfo.dashboardId = dashboardId;
      
      const { pathname } = history.location;
      // isView 为true 是预览页面
      const isView = pathname?.indexOf
      ('MyDashboard/ViewPage') !== -1;
      
      if (isTemplateReport) { // 模板页面
        // isView为true是 模板预览页面; false是模板编辑页面
        params.pageId = isView ? '601601' : '601602';
      } else { // 普通报表页面
        // isView为true是 报表预览页面; false是报表编辑页面
        params.pageId = isView ? '601301' : '601202';
      }
      
    }
    
  }
  
  // 因为 舆情的source是2, 所以使用operationLog方法
  const data = {
    logType: 'buttonLog',
    openId: '',
    buttonLog: {
      source: 1,
      uidType: 'game_code',
      buttonId: `${params.pageId || ''}${buttonId}`,
      buttonName,
      extInfo: JSON.stringify(allExtInfo),
      ...params,
    }
  };
  operationLog(data).then(()=>{}).catch((e)=>{console.log(e)});
};



